import { Injectable } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  private firstSidebarVisibleSubj$ = new BehaviorSubject(
    this.mediaObserver.isActive('xs') ? false : true
  );
  private firstSidebarToggleVisibleSubj$ = new BehaviorSubject(
    this.mediaObserver.isActive('xs') ? false : true
  );
  private secondSidebarVisibleSubj$ = new BehaviorSubject(
    this.mediaObserver.isActive('xs') ? false : true
  );
  private secondSidebarToggleVisibleSubj$ = new BehaviorSubject(
    this.mediaObserver.isActive('xs') ? false : true
  );

  private closeAllSubject = new Subject<void>();
  closeAll$ = this.closeAllSubject.asObservable();

  firstSidebarVisible$ = this.firstSidebarVisibleSubj$.asObservable();
  firstSidebarToggleVisible$ =
    this.firstSidebarToggleVisibleSubj$.asObservable();
  secondSidebarVisible$ = this.secondSidebarVisibleSubj$.asObservable();
  secondSidebarToggleVisible$ =
    this.secondSidebarToggleVisibleSubj$.asObservable();

  constructor(private mediaObserver: MediaObserver) { }

  get firstSidebarVisible() {
    return this.firstSidebarVisibleSubj$.getValue();
  }

  get secondSidebarVisible() {
    return this.secondSidebarVisibleSubj$.getValue();
  }

  setFirstSidebarVisible(v: boolean) {
    this.firstSidebarVisibleSubj$.next(v);
  }

  setFirstSidebarToggleVisible(v: boolean) {
    this.firstSidebarToggleVisibleSubj$.next(v);
  }

  setSecondSidebarVisible(v: boolean) {
    this.secondSidebarVisibleSubj$.next(v);
  }

  setSecondSidebarToggleVisible(v: boolean) {
    this.secondSidebarToggleVisibleSubj$.next(v);
  }

  onCloseAll() {
    this.closeAllSubject.next();
  }

  toggleFirstSidebarVisible() {
    this.firstSidebarVisibleSubj$.next(
      !this.firstSidebarVisibleSubj$.getValue()
    );
  }

  toggleSecondSidebarVisible() {
    this.secondSidebarVisibleSubj$.next(
      !this.secondSidebarVisibleSubj$.getValue()
    );
  }
}
